import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes as RouterRoutes, useNavigate } from "react-router-dom";
import MainComponent from '../Pages/MainComponent';
import Member from '../Pages/Member/Member';
import Leaderboard from '../Pages/Leaderboard/Leaderboard';
import Dashboard from '../Pages/Dashboard/Dashboard';
import DashboardHome from '../Pages/Dashboard/DashboardHome/DashboardHome';
import Users from '../Pages/Member/Users/Users';
import UserGroup from '../Pages/Member/UsersGroup/UsersGroup';
import Signin from '../Pages/Signin/Signin';
import RecentlyRegisteredUser from '../Pages/Member/RecentlyRegisteredUser/RecentlyRegisteredUser';
import { GlobalUserContext, GlobalUserContextPayload } from '../Context/GlobalUserDetailContext';
import GlobalLoader from '../Utils/Layout/GlobalLoader/GlobalLoader';
import ViewUsers from '../Pages/Member/Users/ViewUsers';
import ResetPassword from '../Pages/ResetPasword/ResetPassword';
import Registration from '../Pages/Registration/Registration';
import MarketingAndSalesResources from '../Pages/Dashboard/DashboardMarketingAndSalesResources/DashboardMarketingAndSalesResources';
import DashboardPlan401k from '../Pages/Dashboard/DashboardPlan401k/DashboardPlan401k';
import DashboardRevenueApp from '../Pages/Dashboard/DashboardRevenueApp/DashboardRevenueApp';
import RevenueApp from '../Pages/RevenueApp/RevenueApp';
import Profile from '../Pages/Profile/ProfileHome';
import EditGroup from '../Pages/Member/EditGroup/EditGroup';
import { DashboardContext, DashboardDetailPayload } from '../Context/DashboardDetailContext';
import { useSnackbar } from '../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import VerifyEmail from '../Pages/VerifyEmail/VerifyEmail';
import SsoHome from '../Pages/SsoHome/SsoHome';
import AcrylicTeam from '../Pages/Member/AcrylicTeam/AcrylicTeam';
import { dashboardDetails } from '../Utils/Constant/Constant';
import ViewUserGroup from '../Pages/Member/UsersGroup/ViewUserGroup';
import ProfileAcrylicTeam from '../Pages/Profile/ProfileAcrylicTeam';
import ProfileIndex from '../Pages/Profile/ProfileIndex';
import ProfileHome from '../Pages/Profile/ProfileHome';
import ProfileIntegration from '../Pages/Profile/ProfileIntegration';

const Routes = () => {
    const [flagLoggedIn, setFlagLoggedIn] = useState(false)
    const {
        userLoggedInFlag,
        flagLoader,
        setFlagLoader,
        userProfileDetails,
        setUserProfileDetails,

        userDetails,
        getUserAppWithStatus
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const {
        setDashboardDetails,
        dashboardDetails
    } = useContext(DashboardContext) as DashboardDetailPayload

    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [isInitializing, setIsInitializing] = useState(true);

    useEffect(() => {
        const initializeAll = async () => {
            try {
                setFlagLoader(true);
                const isLoggedIn = await initializeAuth();
                if (isLoggedIn) {
                    await fetchApps();
                }
            }
            catch (err) {
                console.error("Initialization error:", err);
                setFlagLoader(false);
            }
            finally {
                setFlagLoader(false);
                setIsInitializing(false);
            }
        };

        initializeAll();
    }, []);


    const fetchApps = async () => {
        const response = await getUserAppWithStatus();
        if (response?.status) {
            const responseData = response?.data
            if (responseData?.apps) {
                setDashboardDetails({ apps: responseData.apps });
            }
        }
        else {
            setFlagLoader(false);
            const error = response?.data?.error?.message ? response?.data?.error?.message : "Something Went Wrong!";
            showSnackbar(error, "error")
        }
    }

    const initializeAuth = async (): Promise<boolean> => {
        try {
            setFlagLoader(true);
            const response = await userDetails();
            if (response?.status && response?.data) {
                const userMeResponse = response.data;
                setUserProfileDetails(prev => ({
                    ...prev,
                    flagLoggedIn: true,
                    user: userMeResponse.user,
                    accessToken: userMeResponse.accessToken
                }));
                return true;
            }
            else {
                setUserProfileDetails(prev => ({ ...prev, flagLoggedIn: false }));
                return false;
            }
        }
        catch (error) {
            console.error('Auth initialization error:', error);
            setUserProfileDetails(prev => ({ ...prev, flagLoggedIn: false }));
            navigate('/');
            return false;
        }
        finally {
            setFlagLoader(false);
            setIsInitializing(false);
        }
    };


    useEffect(() => {
        if (userProfileDetails?.flagLoggedIn && !userProfileDetails?.user.isVerified) {
            navigate("/verify-user")
        }
    }, [userProfileDetails])


    if (isInitializing) {
        return <GlobalLoader />;
    }

    const isAppInstalled = (appName: any) => {
        return dashboardDetails?.apps?.some(app => app.appName == appName && app.flagInstalled);
    };

    return (
        <>
            {(flagLoader || userProfileDetails.flagLoggedIn == null) && <GlobalLoader />}

            <RouterRoutes>
                {userProfileDetails.flagLoggedIn && userProfileDetails.user.isVerified ? (
                    <Route path="/" element={<MainComponent />}>
                        <Route index element={<DashboardHome />} />

                        <Route path="dashboard" element={<Dashboard />}>
                            <Route index element={<DashboardHome />} />
                            {isAppInstalled('Marketing and Sales Resources') && <Route path="marketing-and-sales" element={<MarketingAndSalesResources />} />}
                            <Route path="401k-fee-comparison" element={<DashboardPlan401k />} />
                            <Route path="revenue" element={<DashboardRevenueApp />} />
                            {/* {isAppInstalled('401(k) Plan Fee Comparison') && <Route path="plan401k" element={<DashboardPlan401k />} />} */}
                        </Route>

                        {userProfileDetails.user.flagAdmin && (
                            <>
                                <Route path="member" element={<Member />}>
                                    <Route index element={<Users />} />
                                    <Route path="users" element={<Users />} />
                                    <Route path="viewUsers" element={<ViewUsers />} />
                                    {/* <Route path="mac-app" element={<MacApp />} /> */}
                                    <Route path="acrylic-team" element={<AcrylicTeam />} />

                                    <Route path="user-groups" element={<UserGroup />} />
                                    <Route path="viewUserGroup" element={<ViewUserGroup />} />
                                    {/* <Route path="recently-registered-user" element={<RecentlyRegisteredUser />} /> */}
                                </Route>
                                {/* <Route path="plan401kfee" element={<DashboardPlan401k />} /> */}
                                <Route path="revenue" element={<DashboardRevenueApp />} />
                                {/* <Route path="revenueapp" element={<RevenueApp />} /> */}
                                {/* ****************  AFTER MIGRATION OF V2 *************** */}
                                {/* <Route path="user-app-access" element={<Leaderboard />} /> */}
                            </>
                        )}

                        <Route path="profile" element={<ProfileIndex />}>
                            <Route index element={<ProfileHome />} />
                            <Route path="home" element={<ProfileHome />} />
                            <Route path="view-acrylic-team" element={<ProfileAcrylicTeam />} />
                            <Route path="integration" element={<ProfileIntegration />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" />} />
                    </Route>
                ) : (
                    <>
                        <Route path="/" element={<Signin />} />
                        <Route path="login" element={<Signin />} />
                        <Route path="register" element={<Registration />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                        <Route path='verify-user' element={<VerifyEmail />} />
                        <Route path='macsso/ssohome' element={<SsoHome />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </>
                )}
            </RouterRoutes>
        </>
    );
}

export default Routes;
